import axios from "axios";
import router from "./router.js";
import store from "@/store";

const instance = axios.create({
    baseURL: process.env.VUE_APP_API,       // <-- здесь
    withCredentials: true,
    timeout: 5000,
});

const rootInstance = axios.create({
    baseURL: process.env.VUE_APP_DOMAIN,       // <-- здесь
    withCredentials: true,
    timeout: 5000,
});

instance.interceptors.request.use(
    (config) => {
        const currency = localStorage.getItem('currency')|| "EUR";
        const lang_id = store.getters["app/currentLanguage"];

        if (config.method === "get") {
            config.params = { ...config.params, currency };
        } else if (["post", "put", "patch"].includes(config.method)) {
            config.data = { ...config.data, lang_id, currency };
        }

        return config;
    },
    (error) => Promise.reject(error)
);

instance.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (!error.response) {
            return Promise.reject(new Error("Network error, please try again later."));
        }
        const { status } = error.response;
        if (status === 401) {
            await store.dispatch("user/changeIsAuth", false);
            router.push({ name: "Home" });
        } else if (status === 403) {
            await store.dispatch("user/changeEmailVerified", false);
            router.push({ name: "EmailVerificationNotice" });
        }
        return Promise.reject(error);
    }
);


export {rootInstance};
export default instance;
